import { Link } from '@mui/material';
import Button from '@mui/material/Button';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { fAPIDate } from 'src/utils/format-time';
import { fCurrencyRupees } from 'src/utils/format-number';

import Label from 'src/components/label';

import { IFactoringBatch, getBatchStatusColor } from 'src/types/cheque-factoring';

type Props = {
  row: IFactoringBatch;
};

export default function BatchTableRow({ row }: Props) {
  const { _id, batchDate, cheques, totalAmountInCents, advanceAmountInCents, displayStatus } = row;

  return (
    <Link
      component={RouterLink}
      href={paths.dashboard.chequeFactoring.batches.view(_id)}
      sx={{ textDecoration: 'none', color: 'inherit', display: 'contents' }}
    >
      <TableRow hover>
        <TableCell sx={{ whiteSpace: 'nowrap', textAlign: 'left' }}>
          {fAPIDate(batchDate)}
        </TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap', textAlign: 'left' }}>{cheques.length}</TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap', textAlign: 'right' }}>
          {fCurrencyRupees(totalAmountInCents)}
        </TableCell>

        <TableCell sx={{ whiteSpace: 'nowrap', textAlign: 'right' }}>
          {fCurrencyRupees(advanceAmountInCents)}
        </TableCell>

        <TableCell sx={{ textAlign: 'left' }}>
          <Label variant="soft" color={getBatchStatusColor(displayStatus)}>
            {displayStatus}
          </Label>
        </TableCell>

        <TableCell align="right" sx={{ px: 1, whiteSpace: 'nowrap' }}>
          <Link component={RouterLink} href={paths.dashboard.chequeFactoring.batches.view(_id)}>
            <Button variant="soft" color="primary">
              View More
            </Button>
          </Link>
        </TableCell>
      </TableRow>
    </Link>
  );
}
